import { render, staticRenderFns } from "./CorporationView.vue?vue&type=template&id=3f48a5e0&scoped=true"
import script from "./CorporationView.vue?vue&type=script&lang=js"
export * from "./CorporationView.vue?vue&type=script&lang=js"
import style0 from "./CorporationView.vue?vue&type=style&index=0&id=3f48a5e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f48a5e0",
  null
  
)

export default component.exports